import {
  SAVED_COLLECTIONS,
  SELECTION, UPDATE_COLLECTION,
  DELETE_COLLECTION
} from './endpoints'
import { vmHttpClient } from '../../instances'

export const getSavedCollectionsList = async (queryParams = '') => vmHttpClient({
  url: SAVED_COLLECTIONS,
  method: 'GET',
  params: new URLSearchParams(queryParams)
})

export const loadSavedCollection = async selection => vmHttpClient({
  url: SELECTION,
  method: 'POST',
  data: {
    collectionId: selection
  }
})

export const updateCollectionData = async ({
  collectionId = '',
  pmEncodedBusinessName = '',
  options = [],
  components = [],
  planningPeriodRange = {},
  productModelId = '',
  isUserExports = false
} = {}) => vmHttpClient({
  url: UPDATE_COLLECTION.replace(':collectionId', collectionId),
  method: 'PUT',
  data: {
    pmEncodedBusinessName,
    isUserExports,
    options,
    components,
    planningPeriodRange,
    productModelId
  }
})

export const updateCollectionName = async ({
  collectionId = '',
  name = ''
} = {}) => vmHttpClient({
  url: UPDATE_COLLECTION.replace(':collectionId', collectionId),
  method: 'PATCH',
  data: {
    name
  }
})

export const deleteCollection = async id => vmHttpClient({
  url: DELETE_COLLECTION.replace(':collectionId', id),
  method: 'DELETE',
  data: {
    collectionId: id
  }
})
